<template>
  <div class="describe">
    <div class="header">
      <div class="title">一键开启智能家居生活</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="left">
        <img :src="homefurnishingdescribeLogo" alt="" />
      </div>
      <div class="right">
        <div class="title">技术特点</div>
        <div class="text">
          智能家居网络随着集成技术、通信技术、互操作能力和布线标准的实现而不断改进。它涉及对家庭网络内所有的智能家具、设备和系统的操作、管理以及集成技术的应用
        </div>
        <div class="list">
          <div class="item" v-for="item in list" :key="item.id">
            <img :src="item.logo" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import homefurnishingdescribeLogo from "../../../../assets/programme/homefurnishingdescribeLogo.png";
import yesLogo from "../../../../assets/programme/yesLogo.png";

export default {
  setup() {
    return reactive({
      homefurnishingdescribeLogo: homefurnishingdescribeLogo,
      list: [
        {
          id: 1,
          title: "通过家庭网关及其系统软件建立智能家居平台系统",
          logo: yesLogo,
        },
        {
          id: 2,
          title: "统一的平台",
          logo: yesLogo,
        },
        {
          id: 3,
          title: "通过外部扩展模块实现与家电的互连",
          logo: yesLogo,
        },
        {
          id: 4,
          title: "嵌入式系统的应用",
          logo: yesLogo,
        },
      ],
    });
  },
};
</script>

<style scoped>
.describe {
  width: 92vw;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  margin-top: 16px;
}
.body .left img {
  width: 100%;
  margin-bottom: 16px;
}
.body .right .title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.body .right .text {
  margin-top: 12px;
  color: #3d3d3d;
  font-size: 12px;
}
.body .right .list .item {
  display: flex;
  align-items: center;
  margin-top: 16px;
}
.body .right .list .item img {
  width: 16px;
  margin-right: 8px;
}
.body .right .list .item div {
  font-size: 12px;
  color: #2A3D50;
}
</style>
